module.exports = __webpack_public_path__ + "media/images/user_icon-88ddfc7bc1aa3bdd8d1819549d7343b5.png";